export const CR = "\r".charCodeAt(0);
export const LF = "\n".charCodeAt(0);
export const NULL = "\0".charCodeAt(0);
export const COLON = ":".charCodeAt(0);
export const SPACE = " ".charCodeAt(0);
export const TRAILING_NEWLINE = [CR, LF];
